import { env } from '@shared/config';
import { NavigationLib } from '@shared/lib';
import { injectAppContext } from '@shared/app-context';
import { firebaseEntity } from '@entities/firebase';

/**
 * @description During a flash sale managers take requests on WhatsApp instead of the request form
 */
export const useOpenRequest = () => {
  const appContext = injectAppContext();
  const isFlashSaleActive = firebaseEntity.model.useIsFlashSaleActive();

  const openRequest = (openForm: () => void) => {
    if (!isFlashSaleActive.value) {
      openForm();
      return;
    }

    NavigationLib.openLink({
      link: env.WHATSAPP_URL,
      target: '_blank',
      isWebview: appContext.isWebview,
    });
  };

  return { openRequest };
};
